import axios from 'axios';

export default async (id) => {
  return await axios.post(`v2/affiliates/${id}/approve-profile-info`).then(({ data: res }) => {
    return res;
  });
};
